{
  "INTEGRATION_APPS": {
    "FETCHING": "Отримання інтеграцій",
    "NO_HOOK_CONFIGURED": "Немає сконфігурованих інтеграцій {integrationId} в цьому обліковому записі.",
    "HEADER": "Додатки",
    "STATUS": {
      "ENABLED": "Увімкнено",
      "DISABLED": "Вимкнено"
    },
    "CONFIGURE": "Настроїти",
    "ADD_BUTTON": "Додати новий хук",
    "DELETE": {
      "TITLE": {
        "INBOX": "Підтвердіть видалення",
        "ACCOUNT": "Від'єднатись"
      },
      "MESSAGE": {
        "INBOX": "Справді бажаєте видалити?",
        "ACCOUNT": "Ви дійсно бажаєте відключитися?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Так, видалити",
        "ACCOUNT": "Так, відключити"
      },
      "CANCEL_BUTTON_TEXT": "Скасувати",
      "API": {
        "SUCCESS_MESSAGE": "Хук успішно видалено",
        "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
      }
    },
    "LIST": {
      "FETCHING": "Отримання інтеграційних хуків",
      "INBOX": "Вхідні",
      "DELETE": {
        "BUTTON_TEXT": "Видалити"
      },
      "EDIT": {
        "BUTTON_TEXT": "Редагувати"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Вибрати \"Вхідний\" канал",
          "PLACEHOLDER": "Виділити \"Вхідні\""
        },
        "SUBMIT": "Створити",
        "CANCEL": "Скасувати"
      },
      "API": {
        "SUCCESS_MESSAGE": "Хук інтеграції успішно додано",
        "ERROR_MESSAGE": "Не вдалося підключитися до Woot Server, спробуйте ще раз пізніше"
      }
    },
    "EDIT": {
      "TITLE": "Редагувати {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Виберіть канал",
          "PLACEHOLDER": "Виберіть канал"
        },
        "SUBMIT": "Оновити",
        "CANCEL": "Скасувати"
      },
      "API": {
        "SUCCESS_MESSAGE": "Хук інтеграції успішно оновлено",
        "ERROR_MESSAGE": "Не вдалося підключитися до чат-сервера. Спробуйте ще раз пізніше"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Підключитися"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Від'єднатись"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Отримуйте дані з власного сервера та відображайте їх на бічній панелі розмови. Повертає HTML (відображається в iframe) або JSON (відображається як список ключ/значення).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Синхронізуйте електронні листи та веб-чати з обліковим записом daktela.",
      "RETINO": "Retino впорядковує управління поверненнями та претензіями.",
      "MAILSHIP": "Mailship — система управління складом і виконанням замовлень. Перевіряйте статус замовлень, відстеження та деталі відправлення.",
      "RAYNET": "Підключіть обліковий запис Raynet CRM, щоб отримати доступ до даних клієнтів. Додайте підключення, вказавши ім'я користувача та API-токен Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Перевірити підключення",
      "SUCCESS": "Підключення успішне",
      "ERROR": "Не вдалося підключитися. Перевірте облікові дані."
    }
  }
}
